<template>
  <v-container fluid>
    <div class="receipt">
      <div class="paper">
        <div>
          <dl v-if="infoEnvioGeneradaDespues.envio">
            <dt>
              <!-- <div v-for="(paquetes, index) in infoEnvioActual.InfoPaqueteriaN" :key="index"> -->
              <div v-for="(guiaPaquete, index) in guiasAgregadasDespues" :key="index">
                <span v-if="guiaPaquete.length >= 1">
                  [Guía #{{ index + 1 }}]
                  {{ formateaGuia(guiaPaquete) }}
                </span>
              </div>
              <!-- </div> -->
            </dt>
            <dd>#REF: {{ infoEnvioGeneradaDespues.envio.ID }}</dd>
            <dt>Fecha de compra:</dt>
            <dd>{{ infoEnvioGeneradaDespues.envio.Fecha }}</dd>
          </dl>
          <div>
            <span style="font-weight:bold;"> Información envio </span>
            {{ infoEnvioActual.tipoEnvio }} <br />
          </div>
          <!-- es envio mensajeria asi que solo se muestra informacion de mensajeria obvio -->
          <div v-if="infoEnvioActual.InfoMensajeria">
            <span style="font-weight:bold;">Mensajes</span><br />
            <span>Peso: {{ infoEnvioActual.InfoMensajeria.pesokg }} kg.</span>
            <span> </span>
            <span v-if="infoEnvioActual.InfoMensajeria.guiaRastreo">
              Guía FEDEX: {{ formateaGuia(infoEnvioActual.InfoMensajeria.guiaRastreo) }}</span
            ><br />
            <span style="font-weight:bold;">Descripción mensajería: </span
            ><span>{{ infoEnvioActual.DescripcionMensajeriaFinal }}</span>
          </div>
          <!-- si es paqueteria nacional esto  -->
          <div v-if="infoEnvioActual.InfoPaqueteriaN">
            <span style="font-weight:bold;">Paquetes</span>
            <br />
            <div v-for="(paquetes, index) in infoEnvioActual.InfoPaqueteriaN" :key="index">
              #{{ index + 1 }} / Peso: {{ infoEnvioActual.InfoPaqueteriaN[index].pesokg }} kg. /
              Peso vol: {{ infoEnvioActual.InfoPaqueteriaN[index].pesovol }} kg. <br />
              Largo:
              {{ infoEnvioActual.InfoPaqueteriaN[index].largo }} cm / Alto:
              {{ infoEnvioActual.InfoPaqueteriaN[index].alto }} cm / Ancho:
              {{ infoEnvioActual.InfoPaqueteriaN[index].ancho }} cm
              <!-- / Guía:
              {{ formateaGuia(infoEnvioActual.InfoPaqueteriaN[index].guia) }} -->
            </div>
            <div v-if="infoEnvioActual.DescripcionEnvioNacional">
              <span style="font-weight:bold;">Descripción envío nacional: </span
              ><span>{{ infoEnvioActual.DescripcionEnvioNacional }}</span>
            </div>
          </div>
          <div v-if="infoEnvioActual.DescripcionEnvioInter">
            <span style="font-weight:bold;">Descripción envío internacional: </span
            ><span>{{ infoEnvioActual.DescripcionEnvioInter }}</span>
          </div>

          <div>
            <span style="font-weight:bold;"> Remitente </span><br />
            {{ retornaNombreDelRemitente }}
            /
            {{
              infoEnvioActual.InfoRemitente.direccion ? infoEnvioActual.InfoRemitente.direccion : ""
            }}
            / {{ infoEnvioActual.InfoRemitente.colonia }} - {{ infoEnvioActual.InfoRemitente.cp }} /
            {{ infoEnvioActual.InfoRemitente.ciudad }} - {{ infoEnvioActual.InfoRemitente.estado }}
            <br />
          </div>

          <div>
            <span style="font-weight:bold;"> Destinatario </span> <br />
            {{ infoEnvioActual.InfoDestinatario.nombre }} /
            {{ infoEnvioActual.InfoDestinatario.direccion }} /
            {{ infoEnvioActual.InfoDestinatario.colonia }} -
            {{ infoEnvioActual.InfoDestinatario.cp }} /
            {{ infoEnvioActual.InfoDestinatario.ciudad }} -
            {{ infoEnvioActual.InfoDestinatario.estado }} /
            {{ infoEnvioActual.InfoDestinatario.pais }}<br /><br />
          </div>
          <!-- servicios adicionales -->
          <div>
            <dl class="total">
              <dt>Costo de transporte:</dt>
              <dd>
                {{ formateaMoneda(costoTotalJAJA) }}
              </dd>
            </dl>
          </div>
          <div v-if="infoEnvioActual.ServiciosAdicionales">
            <!-- <br />
            <span style="font-weight:bold;;"> Servicios adicionales </span><br /> -->
            <dl v-if="infoEnvioActual.ServiciosAdicionales.entrega_sabado" class="total">
              <dt>Entrega sábado:</dt>
              <dd>{{ formateaMoneda(infoEnvioActual.ServiciosAdicionales.entrega_sabado) }}</dd>
            </dl>
            <dl v-if="infoEnvioActual.ServiciosAdicionales.empaque" class="total">
              <dt>Empaque:</dt>
              <dd>{{ formateaMoneda(infoEnvioActual.ServiciosAdicionales.empaque) }}</dd>
            </dl>
            <dl v-if="infoEnvioActual.ServiciosAdicionales.zona_expedida" class="total">
              <dt>Zona extendida:</dt>
              <dd>{{ formateaMoneda(infoEnvioActual.ServiciosAdicionales.zona_expedida) }}</dd>
            </dl>
            <dl v-if="infoEnvioActual.ServiciosAdicionales.rempaque" class="total">
              <dt>Reempaque:</dt>
              <dd>{{ formateaMoneda(infoEnvioActual.ServiciosAdicionales.rempaque) }}</dd>
            </dl>
            <dl v-if="infoEnvioActual.ServiciosAdicionales.recoleccion" class="total">
              <dt>Recolección:</dt>
              <dd>{{ formateaMoneda(infoEnvioActual.ServiciosAdicionales.recoleccion) }}</dd>
            </dl>
            <dl v-if="infoEnvioActual.ServiciosAdicionales.seguro" class="total">
              <dt>Seguro:</dt>
              <dd>{{ formateaMoneda(infoEnvioActual.ServiciosAdicionales.seguro) }}</dd>
            </dl>
            <dl v-if="infoEnvioActual.ServiciosAdicionales.seguro" class="total">
              <dt>Valor declarado:</dt>
              <dd>
                {{
                  formateaValorDeclarado(infoEnvioActual.ServiciosAdicionales.valorcontenido)
                }}
              </dd>
            </dl>
          </div>

          <dl class="total">
            <dt>Total:</dt>
            <dd style="font-weight:bold;text-decoration: underline;font-size:20px;">
              {{ formateaMoneda(infoEnvioActual.InfoPagos.Total) }}
            </dd>
          </dl>
          <dl class="total">
            <dt>Importe pagado:</dt>
            <dd style="font-weight:bold;text-decoration: underline;font-size:20px;">
              {{ formateaMoneda(infoEnvioActual.InfoPagos.cantidad) }}
            </dd>
          </dl>
          <br />

          <div style="text-align:center;">
            Firma de cliente:<br /><br />
            ________________________________<br />
            <span style="font-weight:bold; font-size:14px;">{{
              infoEnvioActual.InfoRemitente.nombre
            }}</span>
            <br />
            <!-- si tenemos objeto de servicios adicionales pero no tenemos seguro mostramos mensaje de
            que hace falta, tambien si no tenemos el objeto de seguro es porque no se mandó ninguno,
            por lo tanto tambien se deberia mostrar que no se agregó seguro -->
            <div v-if="infoEnvioActual.ServiciosAdicionales">
              <span
                v-if="
                  !infoEnvioActual.ServiciosAdicionales.seguro ||
                    infoEnvioActual.ServiciosAdicionales.seguro == '' ||
                    infoEnvioActual.ServiciosAdicionales.seguro == null
                "
                style="font-size:14px;font-weigth:bold;"
                >MERCANCIA VIAJA SIN SEGURO DE TRANSPORTE Y ES POR CUENTA Y RIESGO DEL REMITENTE Y
                DESTINATARIO.</span
              >
            </div>
            <div v-if="!infoEnvioActual.ServiciosAdicionales">
              <span style="font-size:14px;font-weigth:bold;"
                >MERCANCIA VIAJA SIN SEGURO DE TRANSPORTE Y ES POR CUENTA Y RIESGO DEL REMITENTE Y
                DESTINATARIO.</span
              >
            </div>
            <div style="font-size:14px;">
              <div v-if="infoEnvioActual.InfoPagos.Total - infoEnvioActual.InfoPagos.cantidad > 0">
                Debo(emos) y pagaré(mos) incondicionalmente por este Pagaré a la orden de Araceli
                Jaime Alcantar la cantidad de
                <span style="text-decoration: underline;">
                  {{
                    formateaMoneda(
                      infoEnvioActual.InfoPagos.Total - infoEnvioActual.InfoPagos.cantidad
                    )
                  }}
                </span>
                como se menciona en los términos y condiciones de nuestra página.<br />
              </div>
              Al firmar acepta estar de acuerdo con términos y condiciones del servicio.<br />
              <div v-if="infoEnvioActual.DescripcionEnvioInter == 'MEDAL'">
                MEDICAMENTOS Y ALIMENTOS: Envío bajo responsabilidad de quien lo manda sin
                responsabilidad de la paquetería por FDA.
              </div>
              <div v-if="mostrarFirma == true">
                <img
                  src="../../assets/qr_code.png"
                  style="height:100px;width:100px;"
                  alt="contrato de privacidad"
                />
              </div>
              Consulta el contrato escaneando el código o a través de www.primeroexpress.com/contrato
            </div>
          </div>
          <br />
          <dl>
            <dt>
              Autoriza:
            </dt>
            <dd>
              {{ infoEnvioActual.InfoUsuario.nombre }}
            </dd>
          </dl>

          <!-- la etiqueta de abajo termina el ticket de envio -->
          <hr />
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
import { mapActions, mapState } from "vuex";
export default {
  async beforeMount() {
    await this.getSucursalEnLaQueEstoy(this.logedInUserInfo.sucursal);
  },
  computed: {
    ...mapState("ofuscadorFirma", {
      mostrarFirma: state => state.mostrarFirma
    }),
    ...mapState("enviosInfoEnvio", {
      infoEnvioActual: state => state.infoEnvio,
      infoEnvioGeneradaDespues: state => state.infoEnvioGeneradaDespues,
      guiasAgregadasDespues: state => state.guiasAgregadasDespues
    }),
    ...mapState("sesion", {
      sucursalInfo: state => state.sucursalData,
      logedInUserInfo: state => state.logedInUserInfo
    }),
    ...mapState("abonosEnvios", {
      objetoDatosAbonoSencillo: state => state.objetoDatosAbonoSencillo,
      objetoDatosMultiple: state => state.objetoDatosMultiple,
      objetoDatosCambioDireccion: state => state.objetoDatosCambioDireccion
    }),
    retornaNombreDelRemitente() {
      if (this.infoEnvioActual.Titular != "" && this.infoEnvioActual.Titular != null) {
        return this.infoEnvioActual.Titular;
      } else if (
        this.infoEnvioActual.InfoRemitente.nombre != "" &&
        (this.infoEnvioActual.Titular == "" || this.infoEnvioActual.Titular == null)
      ) {
        return this.infoEnvioActual.InfoRemitente.nombre;
      } else {
        return "n/d";
      }
    },
    costoTotalJAJA() {
      if (this.infoEnvioActual.ServiciosAdicionales) {
        let valorDeSeguros;
        valorDeSeguros =
          parseFloat(
            this.infoEnvioActual.ServiciosAdicionales.entrega_sabado
              ? this.infoEnvioActual.ServiciosAdicionales.entrega_sabado
              : 0
          ) +
          parseFloat(
            this.infoEnvioActual.ServiciosAdicionales.empaque
              ? this.infoEnvioActual.ServiciosAdicionales.empaque
              : 0
          ) +
          parseFloat(
            this.infoEnvioActual.ServiciosAdicionales.rempaque
              ? this.infoEnvioActual.ServiciosAdicionales.rempaque
              : 0
          ) +
          parseFloat(
            this.infoEnvioActual.ServiciosAdicionales.zona_expedida
              ? this.infoEnvioActual.ServiciosAdicionales.zona_expedida
              : 0
          ) +
          parseFloat(
            this.infoEnvioActual.ServiciosAdicionales.recoleccion
              ? this.infoEnvioActual.ServiciosAdicionales.recoleccion
              : 0
          ) +
          parseFloat(
            this.infoEnvioActual.ServiciosAdicionales.seguro
              ? this.infoEnvioActual.ServiciosAdicionales.seguro
              : 0
          );
        return parseFloat(this.infoEnvioActual.InfoPagos.Total) - valorDeSeguros;
      } else {
        return parseFloat(this.infoEnvioActual.InfoPagos.Total);
      }
    }
  },
  methods: {
    ...mapActions("sesion", ["getSucursalEnLaQueEstoy"]),
    formateaGuia(guia) {
      return FormatoGuia(guia);
    },
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    formateaValorDeclarado(valorDeclarado) {
      const monto = Number(valorDeclarado);
      const noTieneValorDeclarado = [
        valorDeclarado === null,
        valorDeclarado === undefined,
        String(valorDeclarado).trim() === '',
        !Number.isFinite(monto),
      ].some((condicion) => condicion);

      if (noTieneValorDeclarado) {
        return FormatoMoneda.format(0);
      }
      return FormatoMoneda.format(monto);
    },
  },
};
</script>
<style lang="css" scoped>
* {
  font-size: 18px/1.5;
  font-family: "Lato", sans-serif;
  box-sizing: border-box;
  align-items: left;
  letter-spacing: -1px;
  line-height: 0.9;
}
body {
  display: flex;
  height: 100vh;
  margin: 0;
  justify-content: center;
  align-items: left;
  font-size: 12px;
}
.receipt {
  align-items: left;
  word-break: break-word;
  width: 302px;
  border: 1px dotted black;
  border-width: 1px 0;
}
.receipt .paper {
  background: white;
  text-align: left;
}
.receipt h1 {
  font-size: 150%;
  margin: 0;
}
.receipt h1,
.receipt .event {
  text-align: center;
  line-height: 1;
}
.receipt dl {
  display: flex;
  flex-wrap: wrap;
  margin: 1.5em 0 0;
}
.receipt dt,
.receipt dd {
  margin: 0;
  width: 50%;
}
.receipt dd {
  text-align: right;
}
.receipt .total {
  margin: 0;
}
.receipt .total:before {
  display: block;
  width: 100%;
  text-align: right;
}
.receipt .total dt {
  text-align: right;
}
.receipt .total dd {
  padding-left: 0.5em;
  text-align: left;
}
</style>
